import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/autocomplete";
import "bootstrap-sass";

import "./citizen.css";

$(document).ready(function () {
    //$('[data-toggle=tooltip]').tooltip();

    $("#lcsg-tb-datepicker").datepicker();

    $($("#lcsg-btn-datepicker")).click(function () {
        $("#lcsg-tb-datepicker").datepicker("show");
    });

    $(function () {
        const availableTags = [
            "ActionScript",
            "AppleScript",
            "Asp",
            "BASIC",
            "C",
            "C++",
            "Clojure",
            "COBOL",
            "ColdFusion",
            "Erlang",
            "Fortran",
            "Groovy",
            "Haskell",
            "Java",
            "JavaScript",
            "Lisp",
            "Perl",
            "PHP",
            "Python",
            "Ruby",
            "Scala",
            "Scheme"
        ];

        $("#lcsg-autocomplete").autocomplete({
            source: availableTags
        });
    });

    $("body").scrollspy({ target: "#lcsg-nav", offset: 100 });
});
